import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { FAQ_ITEM_HOTLINE } from '@/utils/constants/faq/faqHotline';
import { FAQ_ITEM_SEARCH } from '@/utils/constants/faq/faqSearch';
export const FaqSearch = (props) => {
    const { onClickMyPageLink, type = 'default' } = props;
    const items = useMemo(() => {
        switch (type) {
            // ホットライン用項目
            case 'hotline': {
                return FAQ_ITEM_HOTLINE();
            }
            // デフォルト用項目
            default: {
                return FAQ_ITEM_SEARCH(onClickMyPageLink);
            }
        }
    }, [type, onClickMyPageLink]);
    return (_jsxs("div", Object.assign({ className: 'mypage_faq' }, { children: [_jsx("div", Object.assign({ className: 'mypage_faq_header' }, { children: _jsx("h3", Object.assign({ className: 'label' }, { children: "\u3088\u304F\u3042\u308B\u3054\u8CEA\u554F" })) })), _jsx("div", Object.assign({ className: 'mypage_faq_body' }, { children: _jsx("ul", { children: items.map((item, index) => (_jsxs("li", Object.assign({ className: 'mypage_faq_row' }, { children: [_jsx("p", Object.assign({ className: 'mypage_faq_row_q' }, { children: _jsx("span", { children: item.q }) })), _jsx("p", Object.assign({ className: 'mypage_faq_row_a' }, { children: _jsx("span", { children: item.a }) }))] }), `FaqSearchItems_${index + 1}`))) }) }))] })));
};
